import { useDispatch, useSelector } from "react-redux";
import { submitSearchFacet } from "../Actions/FacetedSearch.action";
import clsx from "clsx";
import { translate } from "../Services/translation";
import React from "react";

export function ClearFiltersButton({className}) {
    const dispatch = useDispatch();
    const { facetFilters } = useSelector((state) => state.facetedSearch);

    function onClick() {
        if (facetFilters == null) {
            return;
        }

        const clearedFilters = facetFilters.map(filter => {
            return {...filter, selectedOptions: []};
        });

        dispatch(submitSearchFacet(clearedFilters));
    }

    return (
        <button type="button"
                onClick={onClick}
                className={clsx('btn btn--full btn--transparent', className)}>
            {translate('filter.clear')}
            <svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 320 512"
                 width="1em"
                 height="1em"
                 fill="currentColor"
                 aria-hidden="true"
                 className="btn__icon">
                <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
            </svg>
        </button>
    );
}

export default ClearFiltersButton;